export function readJSON(key) {
    let value = JSON.parse(localStorage.getItem(key));
    
    return (value !== 'undefined' && value !== null) ? value : [];
}

export function read(key,type) {
	let value = '';
	if( type=='json' ) {
		value = JSON.parse(localStorage.getItem(key));
	} else {
		value = localStorage.getItem(key);
	}
    return value 
}

export function write(key, data) {
    return localStorage.setItem(key,JSON.stringify(data));
}

export function each(fn) {
    for (var i = localStorage.length - 1; i >=0; i--) {
        var key = localStorage.key(i)
        fn(read(key), key)
    }
}

export function remove(key) {
    return localStorage.removeItem(key)
}

export function clearAll() {
    return localStorage.clear()
}

export function all(fn,key,data) {
    if(typeof window == "object"){
        switch(fn) {
            case 'read':
                return read(key,data)
            break
            case 'write':
                return write(key,data)
            break
            case 'remove':
                return remove(key,data)
            break
        }
    }
}